export default __webpack_public_path__ + "static/char-43-50e909d4f8ba7c735629e087f5c8d11c.gif";